import styled from 'styled-components';

export const Card = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(
    --ds-background-discovery-bold-hovered,
    var(--ds-fb-background-discovery-bold-hovered)
  );
  border-radius: 3px;
  margin: 0px 8px 8px 8px;
  padding: 8px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0px;
`;

export const CardButtons = styled.div`
  display: flex;
  align-items: center;
  padding-top: 16px;
`;

export const ButtonWrapper = styled.div`
  padding-right: 4px;
`;

export const CardContentWrapper = styled.div`
  padding-top: 8px;
`;
